<template>
  <div class="filter">
    <div class="left">
      <div
        v-for="(item, i) in list"
        :key="i"
        class="tab"
        @click="changeTab(item.value)"
      >
        <p :class="{ text: true, noText: item.value !== curTab }">
          {{ item.name }}
        </p>
        <div :class="{ bar: true, noBar: item.value !== curTab }"></div>
      </div>
    </div>
    <div class="right" @click="showFilter">
      <p>{{ lang('筛选') }}</p>
      <img
        :class="show ? 'rotate180' : 'rotate0'"
        src="../../../../assets/images/score/drop.png"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue'
import lang from '@/langs'

const props = defineProps({
  tabIndex: {
    // 下拉区域始终为全屏的高度
    type: Number,
    default: 0
  },
  show: {
    type: Boolean,
    default: false
  }
})
const show = ref(props.show)
watch(
  () => props.show,
  (value) => {
    show.value = value
  }
)
const emits = defineEmits(['changeTab', 'showFilter'])
const showFilter = () => {
  emits('showFilter')
}
const curTab = ref(props.tabIndex)
watch(
  () => props.tabIndex,
  (value) => {
    curTab.value = value
  }
)
const changeTab = (value: number) => {
  curTab.value = value
  emits('changeTab', value)
}
const list = [
  { name: lang('兑换记录'), value: 0 },
  { name: lang('充值记录'), value: 1 }
]
</script>

<style scoped lang="less">
.filter {
  height: auto;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 16px;
  padding-bottom: 0;
  background: #fff;
  .left {
    display: flex;
    flex-direction: row;
    flex: 1;
    .tab {
      margin-right: 40px;
      align-items: center;
      justify-content: center;
      display: flex;
      flex-direction: column;
      font-size: 14px;
      .bar {
        height: 3px;
        width: 16px;
        border-radius: 2px;
        background: rgba(255, 0, 0, 1);
        margin-top: 13px;
      }
      .noBar {
        background: #fff;
      }
      .text {
        color: rgba(60, 60, 60, 1);
        font-weight: 500;
      }
      .noText {
        color: rgba(153, 153, 153, 1);
        font-weight: 400;
      }
    }
  }
  .right {
    font-size: 14px;
    color: rgba(60, 60, 60, 1);
    display: flex;
    flex-direction: row;
    > img {
      height: 16px;
      width: 16px;
    }
    .rotate180 {
      display: inline-block;
      transform: rotate(180deg); /* 旋转 180 度 */
      transition: transform 0.3s ease; /* 添加平滑过渡（可选） */
    }
    .rotate0 {
      display: inline-block;
      transform: rotate(0deg); /* 旋转 180 度 */
      transition: transform 0.3s ease; /* 添加平滑过渡（可选） */
    }
  }
}
</style>
